import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Loader from './Loader';

const ProtectedRoute = ({ children, requireAdmin = false, requireUser = false, requireGreeter = false, requireFinanceOperator = false }) => {
  const { isAuthenticated, loading, isAdmin, isUser, isGreeter, isFinanceOperator } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loader />;
  }

  if (!isAuthenticated) {
    // Redirect to appropriate login page based on required role
    if (requireGreeter) {
      return <Navigate to="/greeter-login" state={{ from: location }} replace />;
    }
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Check role requirements
  if (requireAdmin && !isAdmin()) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requireUser && !isUser()) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requireGreeter && !isGreeter()) {
    return <Navigate to="/unauthorized" replace />;
  }

  if (requireFinanceOperator && !isFinanceOperator()) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
